import React from 'react';
import Button from 'reactstrap/lib/Button';

export const Warning = ({ warnings, confirmation, hasNHSNumber }) => {
    return <><div className="text-white">
        <h5>Please confirm</h5>

        <p>I consent to share the information I have provided in this booking portal with the National Immunisation and Vaccination Service (NIVS), NHS Digital and my GP</p>

        <p>I will also bring in a list of my current medications and (if applicable) my anticoagulation record book to my appointment.</p>

        {warnings.length !==0 && <p>As you answered the following questions, please read and confirm to proceed.</p>}
        {
            warnings.map((w, i) =>
                <div className="text-white mb-1" style={{ whiteSpace: "pre-wrap" }} key={i}><strong>{w.text}</strong> {w.answer.warningText()}</div>

            )
        }

        <p>I confirm that the information I have provided here is true and complete to the best of my knowledge.</p>

        <p>If you have question about how and why your information is collected and shared, please refer to our website <a href="https://www.guysandstthomas.nhs.uk" target="_blank" rel="noopener noreferrer">www.guysandstthomas.nhs.uk</a> and search for "your health records".</p>

        {!hasNHSNumber && <h5><b>We do not have your NHS number in our records, please ensure that you bring it to your vaccination appointment</b></h5>}

        <Button color="dark" block onClick={() => confirmation(true)}>I have read the above and I am happy to have a vaccine</Button>

        </div>
    </>


}